export const religionList = [
  {Id: '1', Name: 'Hindu'},
  {Id: '2', Name: 'Muslim'},
  {Id: '3', Name: 'Christian'},
  {Id: '4', Name: 'Buddhist'},
  {Id: '5', Name: 'Sikh'},
  {Id: '6', Name: 'Jain'},
  {Id: '7', Name: 'Other'},
];
